import client from 'lib/api/client';

export const getStoreList = ({
  storeListPage,
  addStoreListPage,
  storeListPageSearch,
  addStoreListSearch,
}) =>
  client.get(
    `/store?storeListPage=${storeListPage}&addStoreListPage=${addStoreListPage}&storeListPageSearch=${storeListPageSearch}&addStoreListSearch=${addStoreListSearch}&limit=5`,
  );

export const getStore = id => client.get(`/store/${id}`);

export const uploadPlan = ({ formData }) =>
  client.post('/store/space/image', formData);

export const updatePlan = ({ id, formData }) => {
  client.post(`/store/space/${id}/image`, formData, {
    headers: {
      'X-Method-Override': 'PATCH',
    },
  });
};

export const createStore = ({ storeId, contractId, code, tel, space }) =>
  client.post('/store', {
    storeId,
    contractId,
    code,
    tel,
    space,
  });

export const deletePlace = id =>
  client.post(`/store/${id}`, null, {
    headers: {
      'X-Method-Override': 'DELETE',
    },
  });

export const deleteSpace = ({ storeId, spaceId }) =>
  client.post(
    `/store/${storeId}/space`,
    { id: spaceId },
    {
      headers: {
        'X-Method-Override': 'DELETE',
      },
    },
  );

export const updateStore = ({ id, code, contractId, tel, addedSpace }) =>
  client.post(
    `/store/${id}`,
    {
      code,
      contractId,
      tel,
      space: addedSpace,
    },
    {
      headers: {
        'X-Method-Override': 'PUT',
      },
    },
  );
